import { render, staticRenderFns } from "./LeadsForPartner.vue?vue&type=template&id=0dd622fa&scoped=true&"
import script from "./LeadsForPartner.vue?vue&type=script&lang=ts&"
export * from "./LeadsForPartner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd622fa",
  null
  
)

export default component.exports